import styles from './mochi-progress-step.module.scss';

interface MochiProgressStepProps {
  step: number;
  totalStep: number;
}

export const MochiProgressStep = ({
  step,
  totalStep,
}: MochiProgressStepProps) => {
  const stepList = Array(totalStep).fill('');
  return (
    <div className={styles.progress}>
      <p>
        {step}/{totalStep} {step === totalStep && '即將完成'}
      </p>
      <ul>
        {stepList.map((_, index) => {
          if (step === index + 1) {
            return <li key={index} className={styles.current} />;
          } else if (step > index + 1) {
            return <li key={index} className={styles.active} />;
          } else {
            return <li key={index} />;
          }
        })}
      </ul>
    </div>
  );
};
